import { Building2, Handshake, Users } from 'lucide-react';
import AvatarUploader from '../avatarUploader/avatarUploader';
import { Badge } from '@/components/ui/badge';
import { useTranslation } from 'react-i18next';

const UserHeader = ({
  tabs,
  endComponent,
  avatar,
  user,
  loadingAvatar,
  setAvatar,
  uploaderEnabled,
  isFromSeller,
}) => {
  const { t } = useTranslation('translation', { keyPrefix: 'generic' });
  return (
    <div className='tw-flex tw-flex-col md:tw-flex-row md:tw-items-center md:tw-justify-between tw-gap-6 tw-mb-6'>
      <div className='tw-flex tw-items-center tw-gap-6'>
        <AvatarUploader
          value={avatar}
          onChange={setAvatar}
          userName={user?.name}
          allowedTypes={['image/png', 'image/jpg', 'image/jpeg']}
          maxSizeMB={0.25}
          minWidth={200}
          disabled={loadingAvatar}
          uploaderEnabled={uploaderEnabled}
          minHeight={200}
        />
        <div>
          <div className='tw-flex tw-items-center tw-gap-3'>
            <h1 className='tw-text-3xl tw-font-bold tw-text-gray-900'>{user?.name}</h1>
            {isFromSeller ? (
              <Badge variant='secondary' className='tw-gap-1 tw-mt-1 tw-whitespace-nowrap'>
                {user?.affiliateType === 'INDEPENDENT' ? (
                  <Users className='tw-h-3 tw-w-3' />
                ) : user?.affiliateType === 'INTERNAL_STAFF' ? (
                  <Handshake className='tw-h-3 tw-w-3' />
                ) : (
                  <Building2 className='tw-h-3 tw-w-3' />
                )}
                {user?.affiliateType === 'INDEPENDENT'
                  ? t('independent')
                  : user?.affiliateType === 'INTERNAL_STAFF'
                  ? t('internal_staff')
                  : t('concierge')}
              </Badge>
            ) : null}
          </div>

          <div className='tw-mt-3'>{tabs}</div>
        </div>
      </div>
      <div className='tw-flex tw-gap-3 tw-items-center'>{endComponent}</div>
    </div>
  );
};

export default UserHeader;
